import { render, staticRenderFns } from "./TemplatePacks.vue?vue&type=template&id=9b2e7662&scoped=true"
import script from "./TemplatePacks.vue?vue&type=script&lang=js"
export * from "./TemplatePacks.vue?vue&type=script&lang=js"
import style0 from "./TemplatePacks.vue?vue&type=style&index=0&id=9b2e7662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2e7662",
  null
  
)

export default component.exports